export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 6a6 6 0 110 12 6 6 0 010-12zm-2.432 6.017c-.406-.055-.897.004-1.54.45a4 4 0 007.49 1.437 3.774 3.774 0 01-1.351.062c-1.045-.14-1.964-.691-2.67-1.102-.783-.455-1.351-.77-1.929-.847zM12 8a4 4 0 00-3.519 2.095c.454-.104.904-.12 1.352-.06 1.045.139 1.964.69 2.67 1.1.783.456 1.351.771 1.929.848.406.055.896-.005 1.54-.452A4 4 0 0012 8z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.5 2.5a1 1 0 011 1v17a1 1 0 01-1 1h-17a1 1 0 01-1-1v-17a1 1 0 011-1h17zm-16 17h15v-15h-15v15z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};